const Nt = new Error(
  "apiEndpoint must be a valid url"
), ze = {
  platform: "unknown",
  projectName: "",
  isDebug: !1,
  onError: () => {
  },
  // TODO: all api endpoints should be moved into the network module
  eventPath: "/events",
  metricPath: "/metrics",
  apiEndpoint: "https://cca-lite.coinbase.com",
  // works for production only
  disabled: !1,
  isAlwaysAuthed: !1,
  version: null,
  ricTimeoutScheduleEvent: 1e3,
  // TODO: find better solution to handle reset
  reset: () => {
  }
}, Dt = (e) => {
  if (!e)
    return !1;
  try {
    return new URL(e), !0;
  } catch {
    return !1;
  }
}, Mt = (e) => {
  if (e.apiEndpoint && !Dt(e.apiEndpoint))
    throw Nt;
  return {
    ...ze,
    ...e
  };
};
function _e() {
  return (/* @__PURE__ */ new Date()).getTime();
}
const ke = {
  timeStart: _e(),
  timeOnPagePath: 0,
  prevTimeOnPagePath: 0,
  // TODO re-visit if we need to keep storing
  // sessionDuration and sessionEnd here, it seems we don't
  // need to persist this information.
  sessionDuration: 0,
  sessionEnd: 0,
  sessionStart: 0,
  prevSessionDuration: 0
};
function Ft(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Je = { exports: {} }, Ge = { exports: {} };
(function() {
  var e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", n = {
    // Bit-wise rotation left
    rotl: function(t, r) {
      return t << r | t >>> 32 - r;
    },
    // Bit-wise rotation right
    rotr: function(t, r) {
      return t << 32 - r | t >>> r;
    },
    // Swap big-endian to little-endian and vice versa
    endian: function(t) {
      if (t.constructor == Number)
        return n.rotl(t, 8) & 16711935 | n.rotl(t, 24) & 4278255360;
      for (var r = 0; r < t.length; r++)
        t[r] = n.endian(t[r]);
      return t;
    },
    // Generate an array of any length of random bytes
    randomBytes: function(t) {
      for (var r = []; t > 0; t--)
        r.push(Math.floor(Math.random() * 256));
      return r;
    },
    // Convert a byte array to big-endian 32-bit words
    bytesToWords: function(t) {
      for (var r = [], i = 0, a = 0; i < t.length; i++, a += 8)
        r[a >>> 5] |= t[i] << 24 - a % 32;
      return r;
    },
    // Convert big-endian 32-bit words to a byte array
    wordsToBytes: function(t) {
      for (var r = [], i = 0; i < t.length * 32; i += 8)
        r.push(t[i >>> 5] >>> 24 - i % 32 & 255);
      return r;
    },
    // Convert a byte array to a hex string
    bytesToHex: function(t) {
      for (var r = [], i = 0; i < t.length; i++)
        r.push((t[i] >>> 4).toString(16)), r.push((t[i] & 15).toString(16));
      return r.join("");
    },
    // Convert a hex string to a byte array
    hexToBytes: function(t) {
      for (var r = [], i = 0; i < t.length; i += 2)
        r.push(parseInt(t.substr(i, 2), 16));
      return r;
    },
    // Convert a byte array to a base-64 string
    bytesToBase64: function(t) {
      for (var r = [], i = 0; i < t.length; i += 3)
        for (var a = t[i] << 16 | t[i + 1] << 8 | t[i + 2], s = 0; s < 4; s++)
          i * 8 + s * 6 <= t.length * 8 ? r.push(e.charAt(a >>> 6 * (3 - s) & 63)) : r.push("=");
      return r.join("");
    },
    // Convert a base-64 string to a byte array
    base64ToBytes: function(t) {
      t = t.replace(/[^A-Z0-9+\/]/ig, "");
      for (var r = [], i = 0, a = 0; i < t.length; a = ++i % 4)
        a != 0 && r.push((e.indexOf(t.charAt(i - 1)) & Math.pow(2, -2 * a + 8) - 1) << a * 2 | e.indexOf(t.charAt(i)) >>> 6 - a * 2);
      return r;
    }
  };
  Ge.exports = n;
})();
var Ct = Ge.exports, de = {
  // UTF-8 encoding
  utf8: {
    // Convert a string to a byte array
    stringToBytes: function(e) {
      return de.bin.stringToBytes(unescape(encodeURIComponent(e)));
    },
    // Convert a byte array to a string
    bytesToString: function(e) {
      return decodeURIComponent(escape(de.bin.bytesToString(e)));
    }
  },
  // Binary encoding
  bin: {
    // Convert a string to a byte array
    stringToBytes: function(e) {
      for (var n = [], t = 0; t < e.length; t++)
        n.push(e.charCodeAt(t) & 255);
      return n;
    },
    // Convert a byte array to a string
    bytesToString: function(e) {
      for (var n = [], t = 0; t < e.length; t++)
        n.push(String.fromCharCode(e[t]));
      return n.join("");
    }
  }
}, Pe = de;
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
var Ot = function(e) {
  return e != null && (Ye(e) || xt(e) || !!e._isBuffer);
};
function Ye(e) {
  return !!e.constructor && typeof e.constructor.isBuffer == "function" && e.constructor.isBuffer(e);
}
function xt(e) {
  return typeof e.readFloatLE == "function" && typeof e.slice == "function" && Ye(e.slice(0, 0));
}
(function() {
  var e = Ct, n = Pe.utf8, t = Ot, r = Pe.bin, i = function(a, s) {
    a.constructor == String ? s && s.encoding === "binary" ? a = r.stringToBytes(a) : a = n.stringToBytes(a) : t(a) ? a = Array.prototype.slice.call(a, 0) : !Array.isArray(a) && a.constructor !== Uint8Array && (a = a.toString());
    for (var o = e.bytesToWords(a), m = a.length * 8, l = 1732584193, c = -271733879, u = -1732584194, f = 271733878, d = 0; d < o.length; d++)
      o[d] = (o[d] << 8 | o[d] >>> 24) & 16711935 | (o[d] << 24 | o[d] >>> 8) & 4278255360;
    o[m >>> 5] |= 128 << m % 32, o[(m + 64 >>> 9 << 4) + 14] = m;
    for (var p = i._ff, g = i._gg, v = i._hh, T = i._ii, d = 0; d < o.length; d += 16) {
      var kt = l, Pt = c, bt = u, Lt = f;
      l = p(l, c, u, f, o[d + 0], 7, -680876936), f = p(f, l, c, u, o[d + 1], 12, -389564586), u = p(u, f, l, c, o[d + 2], 17, 606105819), c = p(c, u, f, l, o[d + 3], 22, -1044525330), l = p(l, c, u, f, o[d + 4], 7, -176418897), f = p(f, l, c, u, o[d + 5], 12, 1200080426), u = p(u, f, l, c, o[d + 6], 17, -1473231341), c = p(c, u, f, l, o[d + 7], 22, -45705983), l = p(l, c, u, f, o[d + 8], 7, 1770035416), f = p(f, l, c, u, o[d + 9], 12, -1958414417), u = p(u, f, l, c, o[d + 10], 17, -42063), c = p(c, u, f, l, o[d + 11], 22, -1990404162), l = p(l, c, u, f, o[d + 12], 7, 1804603682), f = p(f, l, c, u, o[d + 13], 12, -40341101), u = p(u, f, l, c, o[d + 14], 17, -1502002290), c = p(c, u, f, l, o[d + 15], 22, 1236535329), l = g(l, c, u, f, o[d + 1], 5, -165796510), f = g(f, l, c, u, o[d + 6], 9, -1069501632), u = g(u, f, l, c, o[d + 11], 14, 643717713), c = g(c, u, f, l, o[d + 0], 20, -373897302), l = g(l, c, u, f, o[d + 5], 5, -701558691), f = g(f, l, c, u, o[d + 10], 9, 38016083), u = g(u, f, l, c, o[d + 15], 14, -660478335), c = g(c, u, f, l, o[d + 4], 20, -405537848), l = g(l, c, u, f, o[d + 9], 5, 568446438), f = g(f, l, c, u, o[d + 14], 9, -1019803690), u = g(u, f, l, c, o[d + 3], 14, -187363961), c = g(c, u, f, l, o[d + 8], 20, 1163531501), l = g(l, c, u, f, o[d + 13], 5, -1444681467), f = g(f, l, c, u, o[d + 2], 9, -51403784), u = g(u, f, l, c, o[d + 7], 14, 1735328473), c = g(c, u, f, l, o[d + 12], 20, -1926607734), l = v(l, c, u, f, o[d + 5], 4, -378558), f = v(f, l, c, u, o[d + 8], 11, -2022574463), u = v(u, f, l, c, o[d + 11], 16, 1839030562), c = v(c, u, f, l, o[d + 14], 23, -35309556), l = v(l, c, u, f, o[d + 1], 4, -1530992060), f = v(f, l, c, u, o[d + 4], 11, 1272893353), u = v(u, f, l, c, o[d + 7], 16, -155497632), c = v(c, u, f, l, o[d + 10], 23, -1094730640), l = v(l, c, u, f, o[d + 13], 4, 681279174), f = v(f, l, c, u, o[d + 0], 11, -358537222), u = v(u, f, l, c, o[d + 3], 16, -722521979), c = v(c, u, f, l, o[d + 6], 23, 76029189), l = v(l, c, u, f, o[d + 9], 4, -640364487), f = v(f, l, c, u, o[d + 12], 11, -421815835), u = v(u, f, l, c, o[d + 15], 16, 530742520), c = v(c, u, f, l, o[d + 2], 23, -995338651), l = T(l, c, u, f, o[d + 0], 6, -198630844), f = T(f, l, c, u, o[d + 7], 10, 1126891415), u = T(u, f, l, c, o[d + 14], 15, -1416354905), c = T(c, u, f, l, o[d + 5], 21, -57434055), l = T(l, c, u, f, o[d + 12], 6, 1700485571), f = T(f, l, c, u, o[d + 3], 10, -1894986606), u = T(u, f, l, c, o[d + 10], 15, -1051523), c = T(c, u, f, l, o[d + 1], 21, -2054922799), l = T(l, c, u, f, o[d + 8], 6, 1873313359), f = T(f, l, c, u, o[d + 15], 10, -30611744), u = T(u, f, l, c, o[d + 6], 15, -1560198380), c = T(c, u, f, l, o[d + 13], 21, 1309151649), l = T(l, c, u, f, o[d + 4], 6, -145523070), f = T(f, l, c, u, o[d + 11], 10, -1120210379), u = T(u, f, l, c, o[d + 2], 15, 718787259), c = T(c, u, f, l, o[d + 9], 21, -343485551), l = l + kt >>> 0, c = c + Pt >>> 0, u = u + bt >>> 0, f = f + Lt >>> 0;
    }
    return e.endian([l, c, u, f]);
  };
  i._ff = function(a, s, o, m, l, c, u) {
    var f = a + (s & o | ~s & m) + (l >>> 0) + u;
    return (f << c | f >>> 32 - c) + s;
  }, i._gg = function(a, s, o, m, l, c, u) {
    var f = a + (s & m | o & ~m) + (l >>> 0) + u;
    return (f << c | f >>> 32 - c) + s;
  }, i._hh = function(a, s, o, m, l, c, u) {
    var f = a + (s ^ o ^ m) + (l >>> 0) + u;
    return (f << c | f >>> 32 - c) + s;
  }, i._ii = function(a, s, o, m, l, c, u) {
    var f = a + (o ^ (s | ~m)) + (l >>> 0) + u;
    return (f << c | f >>> 32 - c) + s;
  }, i._blocksize = 16, i._digestsize = 16, Je.exports = function(a, s) {
    if (a == null)
      throw new Error("Illegal argument " + a);
    var o = e.wordsToBytes(i(a, s));
    return s && s.asBytes ? o : s && s.asString ? r.bytesToString(o) : e.bytesToHex(o);
  };
})();
var At = Je.exports;
const Bt = /* @__PURE__ */ Ft(At), It = (e, n) => Bt(e + n), Rt = "application/json", Ke = (e) => {
  const { data: n, onError: t, url: r } = e, i = Rt, a = JSON.stringify(n);
  fetch(r, {
    method: "POST",
    mode: "no-cors",
    headers: {
      "Content-Type": i
    },
    body: a
  }).catch(t);
}, be = () => {
}, Ut = {
  sendMetrics: be,
  sendEvents: be
};
function jt(e) {
  return e.forEach((n) => {
    n.metricName && (n.metric_name = n.metricName, delete n.metricName), n.metricType && (n.type = n.metricType, delete n.metricType);
  }), e;
}
const Ht = (e) => {
  if (W().isOptOut || e.length === 0)
    return;
  let t;
  try {
    t = JSON.stringify(e);
  } catch (l) {
    let c;
    l instanceof Error ? c = l : (c = new Error("unknown"), c.message = l);
    const u = e.map((d) => d.name).join(", ");
    t = JSON.stringify(e), _().onError(c, {
      listEventName: u,
      stringifiedEventData: t
    });
  }
  const { apiEndpoint: r, eventPath: i, onError: a } = _(), s = _e().toString(), o = {
    e: t,
    checksum: It(t, s)
  }, m = `${r}${i}`;
  Ke({
    url: m,
    data: o,
    onError: a
  });
}, $t = (e) => {
  const { apiEndpoint: n, metricPath: t, onError: r } = _(), i = `${n}${t}`, a = {
    metrics: jt(e)
  };
  Ke({
    url: i,
    data: a,
    onError: r
  });
}, qt = () => ({
  sendMetrics: $t,
  sendEvents: Ht
}), Qe = () => {
  const e = [];
  return {
    add: (i) => {
      e.push(i);
    },
    pop: () => e.shift(),
    flush: () => {
      e.length = 0;
    },
    get length() {
      return e.length;
    },
    items: e
  };
}, Wt = 30, Vt = 5e3, Le = {
  queue: Qe(),
  add: () => {
  },
  items: [],
  length: 0
}, zt = (e, n = Wt, t = Vt) => {
  const r = Qe(), i = (o, m = "low") => {
    r.add(o), (r.length >= n || m === "high") && a();
  }, a = () => {
    r.length !== 0 && (e(r.items), r.flush());
  }, s = () => setTimeout(() => {
    a(), s();
  }, t);
  return s(), {
    queue: r,
    add: i,
    get items() {
      return r.items;
    },
    get length() {
      return r.length;
    }
  };
}, Ne = {
  // Session definitions
  lastEventTime: 0,
  sessionStart: 0,
  sessionUUID: null,
  userId: null
}, Ze = () => {
  const e = _();
  return e.platform === "unknown" ? (e.onError(new Error("SDK platform not initialized")), !1) : !0;
}, Jt = (e) => e, Xe = (...e) => e.reverse().reduce(
  (n, t) => (r) => n(t(r)),
  Jt
), Gt = () => {
  const e = W();
  e.languageCode = (navigator == null ? void 0 : navigator.languages[0]) || (navigator == null ? void 0 : navigator.language) || "";
}, Yt = (e) => {
  const n = St();
  n.height = e.height, n.width = e.width;
}, Kt = () => {
  var n;
  const e = St();
  e.userAgent = ((n = window == null ? void 0 : window.navigator) == null ? void 0 : n.userAgent) || null;
}, Qt = () => {
  Kt(), Yt({
    height: (window == null ? void 0 : window.innerHeight) ?? null,
    width: (window == null ? void 0 : window.innerWidth) ?? null
  });
}, Zt = () => {
  Gt();
}, Xt = () => {
  Qt();
}, en = (e) => {
  const n = x();
  return !e.pagePath && n.pagePath && (e.pagePath = n.pagePath), e;
}, tn = (e) => {
  var r;
  const n = W(), t = _();
  return e.tags = {
    auth: n.isAuthed() ? "loggedIn" : "notLoggedIn",
    platform: t.platform,
    project_name: t.projectName,
    ...e.tags,
    locale: n.locale ?? "",
    version_name: ((r = t.version) == null ? void 0 : r.toString()) || ""
  }, e;
}, nn = (e) => {
  const n = _e(), t = {
    ...e
  }, r = W(), i = _();
  if (Object.keys(t).length === 0) {
    i.onError(new Error("missing logData"));
    const s = {
      ...De("unknown", "unknown", "unknown"),
      // missing logData so action, component, and name are unknown
      locale: r.locale,
      session_lcc_id: r.session_lcc_id,
      timestamp: n,
      time_start: ke.timeStart
    };
    return Object.assign(e, s), e;
  }
  const a = {
    ...t,
    ...De(t.action, t.component, t.name),
    locale: r.locale,
    session_lcc_id: r.session_lcc_id,
    timestamp: n,
    time_start: ke.timeStart
  };
  return Object.assign(e, a), e;
}, De = (e, n, t) => {
  const r = _();
  return {
    auth: W().isAuthed() ? "loggedIn" : "notLoggedIn",
    action: e,
    component: n,
    name: t,
    platform: r.platform,
    project_name: r.projectName
  };
}, rn = (e) => {
  const n = x();
  return n.pageviewConfig.isEnabled && Object.assign(e, jn(n)), e;
}, on = (e) => {
  const n = x();
  return Object.keys(n.initialUAAData).length > 0 ? (n.initialUAAData, Object.assign(e, n.initialUAAData), e) : (n.initialUAAData = {
    ...Hn(),
    ...$n(),
    ...qn()
  }, Object.assign(e, n.initialUAAData), e);
}, an = (e) => Xe(en, tn)(e), cn = (e) => Xe(
  rn,
  on,
  nn
)(e), C = (e, n = "low") => {
  const { config: t, identity: r } = I();
  if (r.isOptOut || t.disabled || !Ze())
    return Promise.resolve(null);
  const i = cn(e);
  return Zn().add(i, n), Promise.resolve(e);
}, sn = "pageview", Z = {
  navigationTiming: {
    eventName: "perf_navigation_timing"
  },
  redirectTime: {
    eventName: "perf_redirect_time"
  },
  RT: {
    eventName: "perf_redirect_time"
  },
  TTFB: {
    eventName: "perf_time_to_first_byte"
  },
  networkInformation: {
    eventName: "perf_network_information"
  },
  storageEstimate: {
    eventName: "perf_storage_estimate"
  },
  FCP: {
    eventName: "perf_first_contentful_paint"
  },
  FID: {
    eventName: "perf_first_input_delay"
  },
  LCP: {
    eventName: "perf_largest_contentful_paint"
  },
  CLS: {
    eventName: "perf_cumulative_layout_shift"
  },
  TBT: {
    eventName: "perf_total_blocking_time"
  },
  NTBT: {
    eventName: "perf_navigation_total_blocking_time"
  },
  INP: {
    eventName: "perf_interact_to_next_paint"
  },
  ET: {
    eventName: "perf_element_timing"
  },
  userJourneyStep: {
    eventName: "perf_user_journey_step"
  }
};
var D = /* @__PURE__ */ ((e) => (e.unknown = "unknown", e.blur = "blur", e.click = "click", e.change = "change", e.dismiss = "dismiss", e.focus = "focus", e.hover = "hover", e.select = "select", e.measurement = "measurement", e.move = "move", e.process = "process", e.render = "render", e.scroll = "scroll", e.view = "view", e.search = "search", e.keyPress = "keyPress", e))(D || {}), M = /* @__PURE__ */ ((e) => (e.unknown = "unknown", e.banner = "banner", e.button = "button", e.card = "card", e.chart = "chart", e.content_script = "content_script", e.dropdown = "dropdown", e.link = "link", e.page = "page", e.modal = "modal", e.table = "table", e.search_bar = "search_bar", e.service_worker = "service_worker", e.text = "text", e.text_input = "text_input", e.tray = "tray", e.checkbox = "checkbox", e.icon = "icon", e))(M || {}), S = /* @__PURE__ */ ((e) => (e.count = "count", e.rate = "rate", e.gauge = "gauge", e.distribution = "distribution", e.histogram = "histogram", e))(S || {});
const N = (e) => {
  if (_().disabled || !Ze())
    return Promise.resolve(null);
  const t = an(e);
  return Qn().add(t), Promise.resolve(e);
};
var A, R, h = { isResourceTiming: !1, isElementTiming: !1, maxTime: 3e4, reportOptions: {} }, j = window, un = j.console, w = j.navigator, F = j.performance, me = function() {
  return w.deviceMemory;
}, ve = function() {
  return w.hardwareConcurrency;
}, te = function() {
  return F && !!F.getEntriesByType && !!F.now && !!F.mark;
}, et = "4g", tt = !1, ne = {}, nt = { value: 0 }, pe = { value: { beacon: 0, css: 0, fetch: 0, img: 0, other: 0, script: 0, total: 0, xmlhttprequest: 0 } }, ge = { value: 0 }, z = { value: 0 }, Me = {}, Y = { isHidden: !1, didChange: !1 }, ln = function() {
  Y.isHidden = !1, document.hidden && (Y.isHidden = document.hidden, Y.didChange = !0);
}, he = function(e, n) {
  try {
    var t = new PerformanceObserver(function(r) {
      n(r.getEntries());
    });
    return t.observe({ type: e, buffered: !0 }), t;
  } catch (r) {
    un.warn("Perfume.js:", r);
  }
  return null;
}, rt = function() {
  return !!(ve() && ve() <= 4) || !!(me() && me() <= 4);
}, fn = function(e, n) {
  switch (e) {
    case "slow-2g":
    case "2g":
    case "3g":
      return !0;
    default:
      return rt() || n;
  }
}, ae = function(e) {
  return parseFloat(e.toFixed(4));
}, V = function(e) {
  return typeof e != "number" ? null : ae(e / Math.pow(1024, 2));
}, it = function(e, n, t, r, i) {
  var a, s = function() {
    h.analyticsTracker && (Y.isHidden && !["CLS", "INP"].includes(e) || h.analyticsTracker({ attribution: r, metricName: e, data: n, navigatorInformation: w ? { deviceMemory: me() || 0, hardwareConcurrency: ve() || 0, serviceWorkerStatus: "serviceWorker" in w ? w.serviceWorker.controller ? "controlled" : "supported" : "unsupported", isLowEndDevice: rt(), isLowEndExperience: fn(et, tt) } : {}, rating: t, navigationType: i }));
  };
  ["CLS", "INP"].includes(e) ? s() : (a = s, "requestIdleCallback" in j ? j.requestIdleCallback(a, { timeout: 3e3 }) : a());
}, dn = function(e) {
  e.forEach(function(n) {
    if (!(n.name !== "self" || n.startTime < nt.value)) {
      var t = n.duration - 50;
      t > 0 && (ge.value += t, z.value += t);
    }
  });
};
(function(e) {
  e.instant = "instant", e.quick = "quick", e.moderate = "moderate", e.slow = "slow", e.unavoidable = "unavoidable";
})(A || (A = {}));
var O, K, ot, re, Te;
(R = {})[A.instant] = { vitalsThresholds: [100, 200], maxOutlierThreshold: 1e4 }, R[A.quick] = { vitalsThresholds: [200, 500], maxOutlierThreshold: 1e4 }, R[A.moderate] = { vitalsThresholds: [500, 1e3], maxOutlierThreshold: 1e4 }, R[A.slow] = { vitalsThresholds: [1e3, 2e3], maxOutlierThreshold: 1e4 }, R[A.unavoidable] = { vitalsThresholds: [2e3, 5e3], maxOutlierThreshold: 2e4 };
var se = { RT: [100, 200], TBT: [200, 600], NTBT: [200, 600] }, we = function(e, n) {
  return se[e] ? n <= se[e][0] ? "good" : n <= se[e][1] ? "needsImprovement" : "poor" : null;
}, H = function(e, n, t) {
  Object.keys(n).forEach(function(r) {
    typeof n[r] == "number" && (n[r] = ae(n[r]));
  }), it(e, n, null, t || {});
}, P = function(e) {
  var n = e.attribution, t = e.name, r = e.rating, i = e.value, a = e.navigationType;
  t === "FCP" && (nt.value = i), ["FCP", "LCP"].includes(t) && !Me[0] && (Me[0] = he("longtask", dn)), t === "FID" && setTimeout(function() {
    Y.didChange || (P({ attribution: n, name: "TBT", rating: we("TBT", ge.value), value: ge.value, navigationType: a }), H("dataConsumption", pe.value));
  }, 1e4);
  var s = ae(i);
  s <= h.maxTime && s >= 0 && it(t, s, r, n, a);
}, $ = function() {
  return window.performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
}, J = function(e) {
  if (document.readyState === "loading")
    return "loading";
  var n = $();
  if (n) {
    if (e < n.domInteractive)
      return "loading";
    if (n.domContentLoadedEventStart === 0 || e < n.domContentLoadedEventStart)
      return "dom-interactive";
    if (n.domComplete === 0 || e < n.domComplete)
      return "dom-content-loaded";
  }
  return "complete";
}, mn = function(e) {
  var n = e.nodeName;
  return e.nodeType === 1 ? n.toLowerCase() : n.toUpperCase().replace(/^#/, "");
}, ee = function(e, n) {
  var t = "";
  try {
    for (; e && e.nodeType !== 9; ) {
      var r = e, i = r.id ? "#" + r.id : mn(r) + (r.classList && r.classList.value && r.classList.value.trim() && r.classList.value.trim().length ? "." + r.classList.value.trim().replace(/\s+/g, ".") : "");
      if (t.length + i.length > (n || 100) - 1)
        return t || i;
      if (t = t ? i + ">" + t : i, r.id)
        break;
      e = r.parentNode;
    }
  } catch {
  }
  return t;
}, at = -1, ct = function() {
  return at;
}, B = function(e) {
  addEventListener("pageshow", function(n) {
    n.persisted && (at = n.timeStamp, e(n));
  }, !0);
}, ce = function() {
  var e = $();
  return e && e.activationStart || 0;
}, E = function(e, n) {
  var t = $(), r = "navigate";
  return ct() >= 0 ? r = "back-forward-cache" : t && (document.prerendering || ce() > 0 ? r = "prerender" : document.wasDiscarded ? r = "restore" : t.type && (r = t.type.replace(/_/g, "-"))), { name: e, value: n === void 0 ? -1 : n, rating: "good", delta: 0, entries: [], id: "v3-".concat(Date.now(), "-").concat(Math.floor(8999999999999 * Math.random()) + 1e12), navigationType: r };
}, q = function(e, n, t) {
  try {
    if (PerformanceObserver.supportedEntryTypes.includes(e)) {
      var r = new PerformanceObserver(function(i) {
        Promise.resolve().then(function() {
          n(i.getEntries());
        });
      });
      return r.observe(Object.assign({ type: e, buffered: !0 }, t || {})), r;
    }
  } catch {
  }
}, y = function(e, n, t, r) {
  var i, a;
  return function(s) {
    n.value >= 0 && (s || r) && ((a = n.value - (i || 0)) || i === void 0) && (i = n.value, n.delta = a, n.rating = function(o, m) {
      return o > m[1] ? "poor" : o > m[0] ? "needs-improvement" : "good";
    }(n.value, t), e(n));
  };
}, Ee = function(e) {
  requestAnimationFrame(function() {
    return requestAnimationFrame(function() {
      return e();
    });
  });
}, ie = function(e) {
  var n = function(t) {
    t.type !== "pagehide" && document.visibilityState !== "hidden" || e(t);
  };
  addEventListener("visibilitychange", n, !0), addEventListener("pagehide", n, !0);
}, ye = function(e) {
  var n = !1;
  return function(t) {
    n || (e(t), n = !0);
  };
}, U = -1, Fe = function() {
  return document.visibilityState !== "hidden" || document.prerendering ? 1 / 0 : 0;
}, oe = function(e) {
  document.visibilityState === "hidden" && U > -1 && (U = e.type === "visibilitychange" ? e.timeStamp : 0, vn());
}, Ce = function() {
  addEventListener("visibilitychange", oe, !0), addEventListener("prerenderingchange", oe, !0);
}, vn = function() {
  removeEventListener("visibilitychange", oe, !0), removeEventListener("prerenderingchange", oe, !0);
}, Se = function() {
  return U < 0 && (U = Fe(), Ce(), B(function() {
    setTimeout(function() {
      U = Fe(), Ce();
    }, 0);
  })), { get firstHiddenTime() {
    return U;
  } };
}, Q = function(e) {
  document.prerendering ? addEventListener("prerenderingchange", function() {
    return e();
  }, !0) : e();
}, Oe = [1800, 3e3], xe = function(e, n) {
  n = n || {}, Q(function() {
    var t, r = Se(), i = E("FCP"), a = q("paint", function(s) {
      s.forEach(function(o) {
        o.name === "first-contentful-paint" && (a.disconnect(), o.startTime < r.firstHiddenTime && (i.value = Math.max(o.startTime - ce(), 0), i.entries.push(o), t(!0)));
      });
    });
    a && (t = y(e, i, Oe, n.reportAllChanges), B(function(s) {
      i = E("FCP"), t = y(e, i, Oe, n.reportAllChanges), Ee(function() {
        i.value = performance.now() - s.timeStamp, t(!0);
      });
    }));
  });
}, Ae = [0.1, 0.25], G = { passive: !0, capture: !0 }, pn = /* @__PURE__ */ new Date(), Be = function(e, n) {
  O || (O = n, K = e, ot = /* @__PURE__ */ new Date(), ut(removeEventListener), st());
}, st = function() {
  if (K >= 0 && K < ot - pn) {
    var e = { entryType: "first-input", name: O.type, target: O.target, cancelable: O.cancelable, startTime: O.timeStamp, processingStart: O.timeStamp + K };
    re.forEach(function(n) {
      n(e);
    }), re = [];
  }
}, gn = function(e) {
  if (e.cancelable) {
    var n = (e.timeStamp > 1e12 ? /* @__PURE__ */ new Date() : performance.now()) - e.timeStamp;
    e.type == "pointerdown" ? function(t, r) {
      var i = function() {
        Be(t, r), s();
      }, a = function() {
        s();
      }, s = function() {
        removeEventListener("pointerup", i, G), removeEventListener("pointercancel", a, G);
      };
      addEventListener("pointerup", i, G), addEventListener("pointercancel", a, G);
    }(n, e) : Be(n, e);
  }
}, ut = function(e) {
  ["mousedown", "keydown", "touchstart", "pointerdown"].forEach(function(n) {
    return e(n, gn, G);
  });
}, Ie = [100, 300], hn = function(e, n) {
  n = n || {}, Q(function() {
    var t, r = Se(), i = E("FID"), a = function(m) {
      m.startTime < r.firstHiddenTime && (i.value = m.processingStart - m.startTime, i.entries.push(m), t(!0));
    }, s = function(m) {
      m.forEach(a);
    }, o = q("first-input", s);
    t = y(e, i, Ie, n.reportAllChanges), o && ie(ye(function() {
      s(o.takeRecords()), o.disconnect();
    })), o && B(function() {
      var m;
      i = E("FID"), t = y(e, i, Ie, n.reportAllChanges), re = [], K = -1, O = null, ut(addEventListener), m = a, re.push(m), st();
    });
  });
}, lt = 0, ue = 1 / 0, X = 0, Tn = function(e) {
  e.forEach(function(n) {
    n.interactionId && (ue = Math.min(ue, n.interactionId), X = Math.max(X, n.interactionId), lt = X ? (X - ue) / 7 + 1 : 0);
  });
}, ft = function() {
  return Te ? lt : performance.interactionCount || 0;
}, En = function() {
  "interactionCount" in performance || Te || (Te = q("event", Tn, { type: "event", buffered: !0, durationThreshold: 0 }));
}, Re = [200, 500], dt = 0, Ue = function() {
  return ft() - dt;
}, b = [], le = {}, je = function(e) {
  var n = b[b.length - 1], t = le[e.interactionId];
  if (t || b.length < 10 || e.duration > n.latency) {
    if (t)
      t.entries.push(e), t.latency = Math.max(t.latency, e.duration);
    else {
      var r = { id: e.interactionId, latency: e.duration, entries: [e] };
      le[r.id] = r, b.push(r);
    }
    b.sort(function(i, a) {
      return a.latency - i.latency;
    }), b.splice(10).forEach(function(i) {
      delete le[i.id];
    });
  }
}, yn = function(e, n) {
  (function(t, r) {
    r = r || {}, Q(function() {
      var i;
      En();
      var a, s = E("INP"), o = function(l) {
        l.forEach(function(f) {
          f.interactionId && je(f), f.entryType === "first-input" && !b.some(function(d) {
            return d.entries.some(function(p) {
              return f.duration === p.duration && f.startTime === p.startTime;
            });
          }) && je(f);
        });
        var c, u = (c = Math.min(b.length - 1, Math.floor(Ue() / 50)), b[c]);
        u && u.latency !== s.value && (s.value = u.latency, s.entries = u.entries, a());
      }, m = q("event", o, { durationThreshold: (i = r.durationThreshold) !== null && i !== void 0 ? i : 40 });
      a = y(t, s, Re, r.reportAllChanges), m && ("interactionId" in PerformanceEventTiming.prototype && m.observe({ type: "first-input", buffered: !0 }), ie(function() {
        o(m.takeRecords()), s.value < 0 && Ue() > 0 && (s.value = 0, s.entries = []), a(!0);
      }), B(function() {
        b = [], dt = ft(), s = E("INP"), a = y(t, s, Re, r.reportAllChanges);
      }));
    });
  })(function(t) {
    (function(r) {
      if (r.entries.length) {
        var i = r.entries.sort(function(a, s) {
          return s.duration - a.duration || s.processingEnd - s.processingStart - (a.processingEnd - a.processingStart);
        })[0];
        r.attribution = { eventTarget: ee(i.target), eventType: i.name, eventTime: i.startTime, eventEntry: i, loadState: J(i.startTime) };
      } else
        r.attribution = {};
    })(t), e(t);
  }, n);
}, He = [2500, 4e3], fe = {}, $e = [800, 1800], _n = function e(n) {
  document.prerendering ? Q(function() {
    return e(n);
  }) : document.readyState !== "complete" ? addEventListener("load", function() {
    return e(n);
  }, !0) : setTimeout(n, 0);
}, wn = function(e, n) {
  n = n || {};
  var t = E("TTFB"), r = y(e, t, $e, n.reportAllChanges);
  _n(function() {
    var i = $();
    if (i) {
      var a = i.responseStart;
      if (a <= 0 || a > performance.now())
        return;
      t.value = Math.max(a - ce(), 0), t.entries = [i], r(!0), B(function() {
        t = E("TTFB", 0), (r = y(e, t, $e, n.reportAllChanges))(!0);
      });
    }
  });
}, Sn = function(e) {
  e.forEach(function(n) {
    n.identifier && P({ attribution: { identifier: n.identifier }, name: "ET", rating: null, value: n.startTime });
  });
}, kn = function(e) {
  e.forEach(function(n) {
    if (h.isResourceTiming && H("resourceTiming", n), n.decodedBodySize && n.initiatorType) {
      var t = n.decodedBodySize / 1e3;
      pe.value[n.initiatorType] += t, pe.value.total += t;
    }
  });
}, Pn = function() {
  (function(e, n) {
    wn(function(t) {
      (function(r) {
        if (r.entries.length) {
          var i = r.entries[0], a = i.activationStart || 0, s = Math.max(i.domainLookupStart - a, 0), o = Math.max(i.connectStart - a, 0), m = Math.max(i.requestStart - a, 0);
          r.attribution = { waitingTime: s, dnsTime: o - s, connectionTime: m - o, requestTime: r.value - m, navigationEntry: i };
        } else
          r.attribution = { waitingTime: 0, dnsTime: 0, connectionTime: 0, requestTime: 0 };
      })(t), e(t);
    }, n);
  })(function(e) {
    e.value > 0 && P(e);
  }, h.reportOptions.ttfb), function(e, n) {
    (function(t, r) {
      r = r || {}, xe(ye(function() {
        var i, a = E("CLS", 0), s = 0, o = [], m = function(c) {
          c.forEach(function(u) {
            if (!u.hadRecentInput) {
              var f = o[0], d = o[o.length - 1];
              s && u.startTime - d.startTime < 1e3 && u.startTime - f.startTime < 5e3 ? (s += u.value, o.push(u)) : (s = u.value, o = [u]);
            }
          }), s > a.value && (a.value = s, a.entries = o, i());
        }, l = q("layout-shift", m);
        l && (i = y(t, a, Ae, r.reportAllChanges), ie(function() {
          m(l.takeRecords()), i(!0);
        }), B(function() {
          s = 0, a = E("CLS", 0), i = y(t, a, Ae, r.reportAllChanges), Ee(function() {
            return i();
          });
        }), setTimeout(i, 0));
      }));
    })(function(t) {
      (function(r) {
        if (r.entries.length) {
          var i = r.entries.reduce(function(o, m) {
            return o && o.value > m.value ? o : m;
          });
          if (i && i.sources && i.sources.length) {
            var a = (s = i.sources).find(function(o) {
              return o.node && o.node.nodeType === 1;
            }) || s[0];
            if (a)
              return void (r.attribution = { largestShiftTarget: ee(a.node), largestShiftTime: i.startTime, largestShiftValue: i.value, largestShiftSource: a, largestShiftEntry: i, loadState: J(i.startTime) });
          }
        }
        var s;
        r.attribution = {};
      })(t), e(t);
    }, n);
  }(function(e) {
    return P(e);
  }, h.reportOptions.cls), function(e, n) {
    xe(function(t) {
      (function(r) {
        if (r.entries.length) {
          var i = $(), a = r.entries[r.entries.length - 1];
          if (i) {
            var s = i.activationStart || 0, o = Math.max(0, i.responseStart - s);
            return void (r.attribution = { timeToFirstByte: o, firstByteToFCP: r.value - o, loadState: J(r.entries[0].startTime), navigationEntry: i, fcpEntry: a });
          }
        }
        r.attribution = { timeToFirstByte: 0, firstByteToFCP: r.value, loadState: J(ct()) };
      })(t), e(t);
    }, n);
  }(function(e) {
    return P(e);
  }, h.reportOptions.fcp), function(e, n) {
    hn(function(t) {
      (function(r) {
        var i = r.entries[0];
        r.attribution = { eventTarget: ee(i.target), eventType: i.name, eventTime: i.startTime, eventEntry: i, loadState: J(i.startTime) };
      })(t), e(t);
    }, n);
  }(function(e) {
    return P(e);
  }, h.reportOptions.fid), function(e, n) {
    (function(t, r) {
      r = r || {}, Q(function() {
        var i, a = Se(), s = E("LCP"), o = function(c) {
          var u = c[c.length - 1];
          u && u.startTime < a.firstHiddenTime && (s.value = Math.max(u.startTime - ce(), 0), s.entries = [u], i());
        }, m = q("largest-contentful-paint", o);
        if (m) {
          i = y(t, s, He, r.reportAllChanges);
          var l = ye(function() {
            fe[s.id] || (o(m.takeRecords()), m.disconnect(), fe[s.id] = !0, i(!0));
          });
          ["keydown", "click"].forEach(function(c) {
            addEventListener(c, function() {
              return setTimeout(l, 0);
            }, !0);
          }), ie(l), B(function(c) {
            s = E("LCP"), i = y(t, s, He, r.reportAllChanges), Ee(function() {
              s.value = performance.now() - c.timeStamp, fe[s.id] = !0, i(!0);
            });
          });
        }
      });
    })(function(t) {
      (function(r) {
        if (r.entries.length) {
          var i = $();
          if (i) {
            var a = i.activationStart || 0, s = r.entries[r.entries.length - 1], o = s.url && performance.getEntriesByType("resource").filter(function(d) {
              return d.name === s.url;
            })[0], m = Math.max(0, i.responseStart - a), l = Math.max(m, o ? (o.requestStart || o.startTime) - a : 0), c = Math.max(l, o ? o.responseEnd - a : 0), u = Math.max(c, s ? s.startTime - a : 0), f = { element: ee(s.element), timeToFirstByte: m, resourceLoadDelay: l - m, resourceLoadTime: c - l, elementRenderDelay: u - c, navigationEntry: i, lcpEntry: s };
            return s.url && (f.url = s.url), o && (f.lcpResourceEntry = o), void (r.attribution = f);
          }
        }
        r.attribution = { timeToFirstByte: 0, resourceLoadDelay: 0, resourceLoadTime: 0, elementRenderDelay: r.value };
      })(t), e(t);
    }, n);
  }(function(e) {
    return P(e);
  }, h.reportOptions.lcp), yn(function(e) {
    return P(e);
  }, h.reportOptions.inp), h.isResourceTiming && he("resource", kn), h.isElementTiming && he("element", Sn);
}, bn = function(e) {
  var n = "usageDetails" in e ? e.usageDetails : {};
  H("storageEstimate", { quota: V(e.quota), usage: V(e.usage), caches: V(n.caches), indexedDB: V(n.indexedDB), serviceWorker: V(n.serviceWorkerRegistrations) });
}, L = { finalMarkToStepsMap: {}, startMarkToStepsMap: {}, active: {}, navigationSteps: {} }, Ln = function() {
  L.startMarkToStepsMap = {}, L.finalMarkToStepsMap = {}, L.active = {}, L.navigationSteps = {};
}, Nn = function(e) {
  if (e === void 0 && (e = {}), h.analyticsTracker = e.analyticsTracker, h.isResourceTiming = !!e.resourceTiming, h.isElementTiming = !!e.elementTiming, h.maxTime = e.maxMeasureTime || h.maxTime, h.reportOptions = e.reportOptions || h.reportOptions, h.steps = e.steps, h.onMarkStep = e.onMarkStep, te()) {
    "PerformanceObserver" in j && Pn(), document.hidden !== void 0 && document.addEventListener("visibilitychange", ln);
    var n = function() {
      if (!te())
        return {};
      var t = F.getEntriesByType("navigation")[0];
      if (!t)
        return {};
      var r = t.responseStart, i = t.responseEnd;
      return { fetchTime: i - t.fetchStart, workerTime: t.workerStart > 0 ? i - t.workerStart : 0, totalTime: i - t.requestStart, downloadTime: i - r, timeToFirstByte: r - t.requestStart, headerSize: t.transferSize - t.encodedBodySize || 0, dnsLookupTime: t.domainLookupEnd - t.domainLookupStart, redirectTime: t.redirectEnd - t.redirectStart };
    }();
    H("navigationTiming", n), n.redirectTime && P({ attribution: {}, name: "RT", rating: we("RT", n.redirectTime), value: n.redirectTime }), H("networkInformation", function() {
      if ("connection" in w) {
        var t = w.connection;
        return typeof t != "object" ? {} : (et = t.effectiveType, tt = !!t.saveData, { downlink: t.downlink, effectiveType: t.effectiveType, rtt: t.rtt, saveData: !!t.saveData });
      }
      return {};
    }()), w && w.storage && typeof w.storage.estimate == "function" && w.storage.estimate().then(bn), h.steps && h.steps && (Ln(), Object.entries(h.steps).forEach(function(t) {
      var r, i, a = t[0], s = t[1].marks, o = s[0], m = s[1], l = (i = L.startMarkToStepsMap[o]) !== null && i !== void 0 ? i : {};
      if (l[a] = !0, L.startMarkToStepsMap[o] = l, L.finalMarkToStepsMap[m]) {
        var c = L.finalMarkToStepsMap[m][o] || [];
        c.push(a), L.finalMarkToStepsMap[m][o] = c;
      } else
        L.finalMarkToStepsMap[m] = ((r = {})[o] = [a], r);
    }));
  }
}, Dn = function(e) {
  te() && !ne[e] && (ne[e] = !0, F.mark("mark_".concat(e, "_start")));
}, Mn = function(e, n, t) {
  if (n === void 0 && (n = {}), t === void 0 && (t = !0), te() && ne[e]) {
    F.mark("mark_".concat(e, "_end")), delete ne[e];
    var r = function(i) {
      F.measure(i, "mark_".concat(i, "_start"), "mark_".concat(i, "_end"));
      var a = F.getEntriesByName(i).pop();
      return a && a.entryType === "measure" ? a.duration : -1;
    }(e);
    t && H(e, ae(r), n);
  }
}, qe = 0, Fn = function() {
  Dn("ntbt"), z.value = 0, clearTimeout(qe), qe = setTimeout(function() {
    Mn("ntbt", {}, !1), P({ attribution: {}, name: "NTBT", rating: we("NTBT", z.value), value: z.value }), z.value = 0;
  }, 2e3);
};
function We(e) {
  return e.toLowerCase();
}
const Cn = 3e4;
let Ve = {};
const On = () => {
  const e = _();
  return {
    analyticsTracker: (n) => {
      const { data: t, attribution: r, metricName: i, navigatorInformation: a, rating: s } = n, o = Z[i], m = (r == null ? void 0 : r.category) || null;
      if (!o && !m)
        return;
      const l = (a == null ? void 0 : a.deviceMemory) || 0, c = (a == null ? void 0 : a.hardwareConcurrency) || 0, u = (a == null ? void 0 : a.isLowEndDevice) || !1, f = (a == null ? void 0 : a.isLowEndExperience) || !1, d = (a == null ? void 0 : a.serviceWorkerStatus) || "unsupported", p = {
        deviceMemory: l,
        hardwareConcurrency: c,
        isLowEndDevice: u,
        isLowEndExperience: f,
        serviceWorkerStatus: d,
        ...Ve
      }, g = {
        is_low_end_device: u,
        is_low_end_experience: f,
        save_data: (t == null ? void 0 : t.saveData) || !1,
        service_worker: d,
        is_perf_metric: !0
      };
      if (i === "navigationTiming")
        t && typeof (t == null ? void 0 : t.redirectTime) == "number" && N({
          metricName: Z.redirectTime.eventName,
          metricType: S.histogram,
          tags: g,
          value: (t == null ? void 0 : t.redirectTime) || 0
        });
      else if (i === "TTFB")
        C({
          name: o.eventName,
          action: D.measurement,
          component: M.page,
          duration: typeof t == "number" ? t : null,
          vitalsScore: s || null,
          ...p
        }), typeof t == "number" && N({
          metricName: Z.TTFB.eventName,
          metricType: S.histogram,
          tags: {
            ...g
          },
          value: t
        }), s && N({
          metricName: `perf_web_vitals_ttfb_${s}`,
          metricType: S.count,
          tags: g,
          value: 1
        });
      else if (i === "networkInformation")
        t != null && t.effectiveType && (Ve = t, C({
          name: o.eventName,
          action: D.measurement,
          component: M.page,
          networkInformationDownlink: t == null ? void 0 : t.downlink,
          networkInformationEffectiveType: t == null ? void 0 : t.effectiveType,
          networkInformationRtt: t == null ? void 0 : t.rtt,
          networkInformationSaveData: t == null ? void 0 : t.saveData,
          navigatorDeviceMemory: l,
          navigatorHardwareConcurrency: c
        }));
      else if (i === "storageEstimate")
        typeof t == "object" && t !== null && C({
          name: o.eventName,
          action: D.measurement,
          component: M.page,
          ...t,
          ...p
        });
      else if (i === "CLS")
        C({
          name: o.eventName,
          action: D.measurement,
          component: M.page,
          score: typeof t == "number" ? t * 100 : null,
          vitalsScore: s || null,
          ...p
        }), s && N({
          metricName: `perf_web_vitals_cls_${s}`,
          metricType: S.count,
          tags: g,
          value: 1
        });
      else if (i === "FID") {
        const v = (r == null ? void 0 : r.performanceEntry) || null, T = parseInt((v == null ? void 0 : v.processingStart) || "");
        C({
          name: o.eventName,
          action: D.measurement,
          component: M.page,
          duration: typeof t == "number" ? t : null,
          processingStart: v != null && v.processingStart ? T : null,
          startTime: v != null && v.startTime ? parseInt(v.startTime) : null,
          vitalsScore: s || null,
          ...p
        }), s && N({
          metricName: `perf_web_vitals_fidVitals_${s}`,
          metricType: S.count,
          tags: g,
          value: 1
        });
      } else
        i === "userJourneyStep" ? (C({
          name: "perf_user_journey_step",
          action: D.measurement,
          component: M.page,
          duration: typeof t == "number" ? t : null,
          rating: s ?? null,
          step_name: (r == null ? void 0 : r.stepName) || "",
          ...p
        }), N({
          metricName: `user_journey_step.${e.projectName}.${e.platform}.${(r == null ? void 0 : r.stepName) || ""}_vitals_${s}`,
          metricType: S.count,
          tags: g,
          value: 1
        }), typeof t == "number" && N({
          metricName: `user_journey_step.${e.projectName}.${e.platform}.${(r == null ? void 0 : r.stepName) || ""}`,
          metricType: S.distribution,
          tags: g,
          value: t
        })) : Z[i] && t && (C({
          name: o.eventName,
          action: D.measurement,
          component: M.page,
          duration: typeof t == "number" ? t : null,
          vitalsScore: s || null,
          ...p
        }), s && (N({
          metricName: `perf_web_vitals_${We(
            i
          )}_${s}`,
          metricType: S.count,
          tags: g,
          value: 1
        }), i === "LCP" && N({
          metricName: `perf_web_vitals_${We(
            i
          )}`,
          metricType: S.distribution,
          tags: g,
          value: t
        })));
    },
    maxMeasureTime: Cn
  };
}, xn = () => {
  Fn();
}, An = () => {
  const e = _();
  try {
    Nn(On());
  } catch (n) {
    n instanceof Error && e.onError(n);
  }
}, mt = {
  breadcrumbs: [],
  initialUAAData: {},
  pagePath: "",
  prevPagePath: "",
  pageviewConfig: {
    isEnabled: !1,
    blacklistRegex: []
  },
  history: void 0
}, vt = [
  "fbclid",
  "gclid",
  "msclkid",
  "ptclid",
  "ttclid",
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content"
];
function er(e) {
  pt({ breadcrumbs: e });
}
function Bn(e) {
  pt({ pageviewConfig: e });
}
function pt(e) {
  const n = x();
  Object.assign(n, structuredClone(e));
}
const gt = () => {
  var e;
  return ((e = window == null ? void 0 : window.location) == null ? void 0 : e.search) || "";
}, ht = () => {
  var e;
  return ((e = window == null ? void 0 : window.location) == null ? void 0 : e.pathname) || "";
}, Tt = () => {
  var e;
  return ((e = window == null ? void 0 : window.location) == null ? void 0 : e.hostname) || "";
};
function Et() {
  return (document == null ? void 0 : document.referrer) ?? "";
}
const In = () => ht() + gt(), Rn = () => {
  const e = x(), n = In();
  !n || n === e.pagePath || (n !== e.pagePath && Un(), e.pagePath = n);
}, Un = () => {
  const e = x(), n = Et();
  if (!e.prevPagePath && n) {
    const t = new URL(n);
    if (t.hostname === Tt()) {
      e.prevPagePath = t.pathname;
      return;
    }
  }
  e.prevPagePath = e.pagePath;
}, jn = (e) => ({
  page_path: e.pagePath,
  prev_page_path: e.prevPagePath
}), Hn = () => {
  const e = {};
  return vt.forEach((n) => {
    Ne[n] && (e[n] = Ne[n]);
  }), e;
}, $n = () => {
  const e = new URLSearchParams(gt()), n = {};
  return vt.forEach((t) => {
    e.has(t) && (n[t] = (e.get(t) || "").toLowerCase());
  }), n;
}, qn = () => {
  const e = Et();
  if (!e)
    return {};
  const n = new URL(e);
  return n.hostname === Tt() ? {} : {
    referrer: e,
    referring_domain: n.hostname
  };
};
function yt(e = { callMarkNTBT: !0 }) {
  const n = _(), {
    pageviewConfig: { blacklistRegex: t }
  } = x();
  n.platform !== "unknown" && (t.some((r) => r.test(ht())) || (C({
    name: sn,
    action: D.render,
    component: M.page
  }), e.callMarkNTBT && xn()));
}
const Wn = (e) => {
  const n = x();
  n.history = e, n.history.listen(() => {
    Rn(), yt();
  });
}, Vn = (e) => {
  const { blacklistRegex: n, isEnabled: t, history: r } = e;
  Bn({ blacklistRegex: n, isEnabled: t }), Wn(r), yt({ callMarkNTBT: !1 });
}, zn = () => structuredClone(mt), _t = {
  countryCode: null,
  deviceId: null,
  device_os: null,
  isOptOut: !1,
  languageCode: null,
  locale: null,
  session_lcc_id: null,
  userAgent: null,
  userId: null,
  isAuthed: () => !1
}, Jn = () => {
  const e = _();
  return {
    ..._t,
    isAuthed: () => e.isAlwaysAuthed || !!W().userId
  };
}, wt = {
  // Device information
  browserName: null,
  browserMajor: null,
  osName: null,
  userAgent: null,
  width: null,
  height: null
}, Gn = () => ({
  ...wt
}), k = {
  config: ze,
  networkLayer: Ut,
  metricScheduler: Le,
  eventScheduler: Le,
  location: mt,
  identity: _t,
  device: wt
}, Yn = {
  createNetworkLayer: qt,
  createScheduler: zt,
  createIdentity: Jn,
  createDevice: Gn,
  createLocation: zn
}, Kn = (e, n) => {
  const t = {
    ...Yn,
    ...n
  };
  k.config = e, k.networkLayer = t.createNetworkLayer(), k.metricScheduler = t.createScheduler(
    k.networkLayer.sendMetrics,
    e.batchMetricsThreshold,
    e.batchMetricsPeriod
  ), k.eventScheduler = t.createScheduler(
    k.networkLayer.sendEvents,
    e.batchEventsThreshold,
    e.batchEventsPeriod
  ), k.identity = t.createIdentity(), k.device = t.createDevice(), k.location = t.createLocation();
}, I = () => k, _ = () => I().config, Qn = () => I().metricScheduler, Zn = () => I().eventScheduler, x = () => I().location, W = () => I().identity, St = () => I().device, Xn = (e, n) => {
  const t = Mt(e);
  Kn(t, n), Zt(), Xt(), An();
}, tr = (e) => (n) => Xn(n, e), nr = ({
  blacklistRegex: e,
  browserHistory: n
}) => {
  Vn({
    blacklistRegex: e || [],
    isEnabled: !0,
    history: n
  });
};
export {
  mt as DEFAULT_LOCATION,
  S as MetricType,
  zn as createLocation,
  Et as getDocumentReferrer,
  In as getPagePath,
  jn as getPageviewProperties,
  qn as getReferrerData,
  Tt as getUrlHostname,
  gt as getUrlParams,
  ht as getUrlPathname,
  Xn as init,
  nr as initTrackPageview,
  tr as injectComponents,
  Hn as persistentUAAData,
  er as setBreadcrumbs,
  pt as setLocation,
  Wn as setLocationHistory,
  Vn as setLocationTracking,
  Rn as setPagePath,
  Bn as setPageviewConfig,
  Un as setPrevPagePath,
  C as trackEvent,
  N as trackMetric,
  yt as trackPageView,
  $n as uaaValuesFromUrl
};
